import React from 'react';
import { KatSpinner } from '@amzn/katal-react';

import index from 'src/index.module.scss';

const LoadingStatusComponent = () => (
  <>
    <div
      className={index['loadingBoxStyle']}
      data-testid="loading-status-component"
    >
      <KatSpinner size="large" />
    </div>
  </>
);

export default LoadingStatusComponent;
